module.exports = __webpack_public_path__ + "img/3.c0f737d5.png";